var a = (r, i, t) => new Promise((d, n) => {
  var s = (e) => {
    try {
      o(t.next(e));
    } catch (c) {
      n(c);
    }
  }, f = (e) => {
    try {
      o(t.throw(e));
    } catch (c) {
      n(c);
    }
  }, o = (e) => e.done ? d(e.value) : Promise.resolve(e.value).then(s, f);
  o((t = t.apply(r, i)).next());
});
import { selfAxios as u } from "@oppein/op-utils";
function p(r) {
  return a(this, null, function* () {
    const { data: i } = yield u.get(
      "/designordercenter/productionOrder/receiver/getDefaultListByServiceId",
      { params: r }
    );
    return i;
  });
}
export {
  p as getGetDefaultListByServiceId
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/receiver/getDefaultListByServiceId/get.js
// module id = 1817
// module chunks = 67